/* eslint-disable array-callback-return */
import React, { useRef, useState, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import { Toolbar } from "primereact/toolbar"
import { Toast } from "primereact/toast"
import PropTypes from "prop-types"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { confirmation } from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
} from "../../../utils/utils"
import ServicesRow from "./ServicesRow"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import { InputText } from "primereact/inputtext"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const PlannedServices1 = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadNext,
    handleLoadPrev,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [plannedServices1, setPlannedServices1] = useState(
    interview[INTERVIEW_SECTIONS.PLANNED_SERVICES_1]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])

  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) => q.section === INTERVIEW_SECTIONS.PLANNED_SERVICES_1
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.PLANNED_SERVICES_1
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, prevForm, setNavigationItem) => {
    updateInterviewValues(
      INTERVIEW_SECTIONS.PLANNED_SERVICES_1,
      plannedServices1
    )
    if (prevForm) {
      handleLoadPrev(true)
      setNextForm(sections[activeIndex - 1].section)
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SERVICES1_DATA, {
          GpraBServicesMod1: plannedServices1?.gpra_b_services_mod_1,
          GpraBServicesMod2: plannedServices1?.gpra_b_services_mod_2,
          GpraBServicesMod3: plannedServices1?.gpra_b_services_mod_3,
          GpraBServicesMod4: plannedServices1?.gpra_b_services_mod_4,
          GpraBServicesMod5: plannedServices1?.gpra_b_services_mod_5,
          GpraBServicesMod6a: plannedServices1?.gpra_b_services_mod_6a,
          GpraBServicesMod6b: plannedServices1?.gpra_b_services_mod_6b,
          GpraBServicesMod6c: plannedServices1?.gpra_b_services_mod_6c,
          GpraBServicesMod6d: plannedServices1?.gpra_b_services_mod_6d,
          GpraBServicesMod6e: plannedServices1?.gpra_b_services_mod_6e,
          GpraBServicesMod6f: plannedServices1?.gpra_b_services_mod_6f,
          GpraBServicesMod6g: plannedServices1?.gpra_b_services_mod_6g,
          GpraBServicesMod6h: plannedServices1?.gpra_b_services_mod_6h,
          GpraBServicesMod6i: plannedServices1?.gpra_b_services_mod_6i,
          GpraBServicesMod7: plannedServices1?.gpra_b_services_mod_7,
          GpraBServicesMod8a: plannedServices1?.gpra_b_services_mod_8a,
          GpraBServicesMod8b: plannedServices1?.gpra_b_services_mod_8b,
          GpraBServicesMod8c: plannedServices1?.gpra_b_services_mod_8c,
          GpraBServicesMod9: plannedServices1?.gpra_b_services_mod_9,
          GpraBServicesMod10: plannedServices1?.gpra_b_services_mod_10,
          GpraBServicesMod11: plannedServices1?.gpra_b_services_mod_11,
          GpraBServicesMod11a: plannedServices1?.gpra_b_services_mod_11a,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraBServicesId: plannedServices1?.gpra_b_services_id,
          Additional: getAdditionalQuestions(plannedServices1),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.PLANNED_SERVICES_1, {
                ...plannedServices1,
                gpra_b_services_id: response.data.gpraBServicesId,
              })
              handleLoadNext(false)
              setNextForm(sections[activeIndex + 1].section)
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ plannedServices1: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      plannedServices1?.gpra_b_services_mod_1 === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_1 = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_2 === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_2 = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_3 === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_3 = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_4 === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_4 = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_5 === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_5 = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_6a === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_6a = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_6b === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_6b = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_6c === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_6c = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_6d === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_6d = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_6e === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_6e = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_6f === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_6f = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_6g === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_6g = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_6h === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_6h = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_6i === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_6i = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_7 === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_7 = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_8a &&
      plannedServices1?.gpra_b_services_mod_8b &&
      !plannedServices1?.gpra_b_services_mod_8c
    ) {
      errors.gpra_b_services_mod_8a = errorMessages.servicesDetoxificationOnly
      errors.gpra_b_services_mod_8b = errorMessages.servicesDetoxificationOnly
      errors.gpra_b_services_mod_8c = errorMessages.servicesDetoxificationOnly
    } else if (
      plannedServices1?.gpra_b_services_mod_8a &&
      !plannedServices1?.gpra_b_services_mod_8b &&
      plannedServices1?.gpra_b_services_mod_8c
    ) {
      errors.gpra_b_services_mod_8a = errorMessages.servicesDetoxificationOnly
      errors.gpra_b_services_mod_8b = errorMessages.servicesDetoxificationOnly
      errors.gpra_b_services_mod_8c = errorMessages.servicesDetoxificationOnly
    } else if (
      !plannedServices1?.gpra_b_services_mod_8a &&
      plannedServices1?.gpra_b_services_mod_8b &&
      plannedServices1?.gpra_b_services_mod_8c
    ) {
      errors.gpra_b_services_mod_8a = errorMessages.servicesDetoxificationOnly
      errors.gpra_b_services_mod_8b = errorMessages.servicesDetoxificationOnly
      errors.gpra_b_services_mod_8c = errorMessages.servicesDetoxificationOnly
    } else if (
      plannedServices1?.gpra_b_services_mod_8a &&
      plannedServices1?.gpra_b_services_mod_8b &&
      plannedServices1?.gpra_b_services_mod_8c
    ) {
      errors.gpra_b_services_mod_8a = errorMessages.servicesDetoxificationOnly
      errors.gpra_b_services_mod_8b = errorMessages.servicesDetoxificationOnly
      errors.gpra_b_services_mod_8c = errorMessages.servicesDetoxificationOnly
    } else if (
      plannedServices1?.gpra_b_services_mod_8a === undefined &&
      plannedServices1?.gpra_b_services_mod_8b === undefined &&
      plannedServices1?.gpra_b_services_mod_8c === undefined
    ) {
      errors.gpra_b_services_mod_8a = errorMessages.servicesDetoxificationOnlyAtLeast
      errors.gpra_b_services_mod_8b = errorMessages.servicesDetoxificationOnlyAtLeast
      errors.gpra_b_services_mod_8c = errorMessages.servicesDetoxificationOnlyAtLeast
    }
    if (
      plannedServices1?.gpra_b_services_mod_9 === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_9 = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_10 === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_10 = errorMessages.requiredMessage
    }
    if (
      plannedServices1?.gpra_b_services_mod_11 === undefined &&
      showQuestion(questions, "gpra_b_services_mod_1")
    ) {
      errors.gpra_b_services_mod_11 = errorMessages.requiredMessage
    } else if (plannedServices1?.gpra_b_services_mod_11) {
      if (!plannedServices1?.gpra_b_services_mod_11a) {
        errors.gpra_b_services_mod_11a = errorMessages.requiredMessage
      }
    }
    console.log("errors", errors)
    setValidationErrors(
      validateQuestions(
        plannedServices1,
        INTERVIEW_SECTIONS.PLANNED_SERVICES_1,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }
  const renderDefaultMain = (question) => {
    if (question.field === "gpra_b_services_mod_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Planned Services PROVIDED UNDER GRANT FUNDING [Reported by program staff about client only at intake/baseline.]`}
            />
            <FormLabel
              label={
                "Identify the services you plan to provide to the client during the client’s course of treatment/recovery. [MARK ONLY THE CIRCLE CORRESPONDING TO THE PLANNED SERVICE THAT WILL BE PROVIDED UNDER THE CURRENT GRANT. MARK ALL THAT APPLY IN EACH SECTION.]"
              }
              indent={false}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel label={"Modality [SELECT AT LEAST ONE MODALITY.]"} />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              options={confirmation}
              label={`1. Case Management`}
              drop={plannedServices1?.gpra_b_services_mod_1}
              setDrop={"gpra_b_services_mod_1"}
              dropError={validationErrors.gpra_b_services_mod_1}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label={`2. Intensive Outpatient Treatment `}
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_2}
              setDrop={"gpra_b_services_mod_2"}
              dropError={validationErrors.gpra_b_services_mod_2}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label={`3. Inpatient/Hospital (Other Than Withdrawal Management)`}
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_3}
              setDrop={"gpra_b_services_mod_3"}
              dropError={validationErrors.gpra_b_services_mod_3}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label={`4. Outpatient Therapy`}
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_4}
              setDrop={"gpra_b_services_mod_4"}
              dropError={validationErrors.gpra_b_services_mod_4}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label={`5. Outreach`}
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_5}
              setDrop={"gpra_b_services_mod_5"}
              dropError={validationErrors.gpra_b_services_mod_5}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              showDrop={false}
              showNumber={false}
              label={`6. Medication`}
              summaryDisabled={disabled}
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="A. Methadone"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_6a}
              setDrop={"gpra_b_services_mod_6a"}
              dropError={validationErrors.gpra_b_services_mod_6a}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="B. Buprenorphine"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_6b}
              setDrop={"gpra_b_services_mod_6b"}
              dropError={validationErrors.gpra_b_services_mod_6b}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="C. Naltrexone – Short Acting"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_6c}
              setDrop={"gpra_b_services_mod_6c"}
              dropError={validationErrors.gpra_b_services_mod_6c}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="D. Naltrexone – Long Acting"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_6d}
              setDrop={"gpra_b_services_mod_6d"}
              dropError={validationErrors.gpra_b_services_mod_6d}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="E. Disulfiram"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_6e}
              setDrop={"gpra_b_services_mod_6e"}
              dropError={validationErrors.gpra_b_services_mod_6e}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="F. Acamprosate"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_6f}
              setDrop={"gpra_b_services_mod_6f"}
              dropError={validationErrors.gpra_b_services_mod_6f}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="G. Nicotine Replacement"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_6g}
              setDrop={"gpra_b_services_mod_6g"}
              dropError={validationErrors.gpra_b_services_mod_6g}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="H. Bupropion"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_6h}
              setDrop={"gpra_b_services_mod_6h"}
              dropError={validationErrors.gpra_b_services_mod_6h}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="I. Varenicline"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_6i}
              setDrop={"gpra_b_services_mod_6i"}
              dropError={validationErrors.gpra_b_services_mod_6i}
              summaryDisabled={disabled}
              indentation
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label={`7. Residential/Rehabilitation`}
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_7}
              setDrop={"gpra_b_services_mod_7"}
              dropError={validationErrors.gpra_b_services_mod_7}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              showDrop={false}
              showNumber={false}
              label={`8. Withdrawal Management (Select Only One)`}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="A. Hospital Inpatient"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_8a}
              setDrop={"gpra_b_services_mod_8a"}
              dropError={validationErrors.gpra_b_services_mod_8a}
              summaryDisabled={
                disabled ||
                plannedServices1?.gpra_b_services_mod_8b === "Yes" ||
                plannedServices1?.gpra_b_services_mod_8c === "Yes"
              }
              errorsToRemove={[
                "gpra_b_services_mod_8a",
                "gpra_b_services_mod_8b",
                "gpra_b_services_mod_8c",
              ]}
              indentation
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="B. Free Standing Residential"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_8b}
              setDrop={"gpra_b_services_mod_8b"}
              dropError={validationErrors.gpra_b_services_mod_8b}
              summaryDisabled={
                disabled ||
                plannedServices1?.gpra_b_services_mod_8a === "Yes" ||
                plannedServices1?.gpra_b_services_mod_8c === "Yes"
              }
              errorsToRemove={[
                "gpra_b_services_mod_8a",
                "gpra_b_services_mod_8b",
                "gpra_b_services_mod_8c",
              ]}
              indentation
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label="C. Ambulatory Detoxification"
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_8c}
              setDrop={"gpra_b_services_mod_8c"}
              dropError={validationErrors.gpra_b_services_mod_8c}
              summaryDisabled={
                disabled ||
                plannedServices1?.gpra_b_services_mod_8a === "Yes" ||
                plannedServices1?.gpra_b_services_mod_8b === "Yes"
              }
              errorsToRemove={[
                "gpra_b_services_mod_8a",
                "gpra_b_services_mod_8b",
                "gpra_b_services_mod_8c",
              ]}
              indentation
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label={`9. After Care`}
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_9}
              setDrop={"gpra_b_services_mod_9"}
              dropError={validationErrors.gpra_b_services_mod_9}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label={`10. Recovery Support`}
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_10}
              setDrop={"gpra_b_services_mod_10"}
              dropError={validationErrors.gpra_b_services_mod_10}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices1}
              setEntity={setPlannedServices1}
              showNumber={false}
              removeError={removeError}
              label={`11. Other (Specify)`}
              options={confirmation}
              drop={plannedServices1?.gpra_b_services_mod_11}
              setDrop={"gpra_b_services_mod_11"}
              dropError={validationErrors.gpra_b_services_mod_11}
              summaryDisabled={disabled}
              extraValues={[{ key: "gpra_b_services_mod_11a", value: "" }]}
              required
            />
            {plannedServices1?.gpra_b_services_mod_11 && (
              <div className={gpraStyles.formServicesRow}>
                <InputText
                  className={
                    validationErrors.gpra_b_services_mod_11a
                      ? gpraStyles.inputText5Error
                      : gpraStyles.inputText5
                  }
                  disabled={
                    !plannedServices1?.gpra_b_services_mod_11 || disabled
                  }
                  placeholder={
                    !plannedServices1?.gpra_b_services_mod_11
                      ? "Not Applicable"
                      : ""
                  }
                  value={plannedServices1?.gpra_b_services_mod_11a}
                  onChange={(e) => {
                    updateState(
                      "gpra_b_services_mod_11a",
                      e.target.value,
                      null,
                      null,
                      plannedServices1,
                      setPlannedServices1,
                      null
                    )
                    removeError("gpra_b_services_mod_11a")
                  }}
                />
                <FormError
                  error={validationErrors.gpra_b_services_mod_11a}
                  errorType={2}
                />
              </div>
            )}
          </div>
        </>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="B. SUBSTANCE USE AND PLANNED SERVICES"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <div
                    style={{
                      marginLeft: "0.5rem",
                      width: "100%",
                      marginTop: "1rem",
                    }}
                  >
                    <AdditionalQuestionContainer
                      entity={plannedServices1}
                      setEntity={setPlannedServices1}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.PLANNED_SERVICES_1}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  </div>
                )
              } else {
                if (checkDisplayConditional(question, plannedServices1)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={plannedServices1}
                      setEntity={setPlannedServices1}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.PLANNED_SERVICES_1}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

PlannedServices1.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}
PlannedServices1.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default PlannedServices1
